"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgrammeCardClient = void 0;
const model_client_1 = require("../../model-client");
class ProgrammeCardClient extends model_client_1.ModelClient {
    getModelName() {
        return 'programme-card';
    }
    getVersion() {
        return 'v1';
    }
    isPublic() {
        return false;
    }
}
exports.ProgrammeCardClient = ProgrammeCardClient;
//# sourceMappingURL=programme-card-client.js.map